import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/personality"
    exact
    path="/business/showcase/personality"
    component={AsyncPage}
  />,
];
